import flatpickr from 'flatpickr'

const $datepickers = document.querySelectorAll('input[type=date]')
const $dateRanges = document.querySelectorAll('.date-range-field')

const fn = {
  init: () => {
    $datepickers.forEach(($input) => {
      flatpickr($input, {
        altInput: true,
        altFormat: 'M j, Y',
        disableMobile: true,
        onReady: function () {
          if (this.input.getAttribute('data-toggle-if')) {
            this.altInput.setAttribute('data-name', this.input.getAttribute('name'))

            this.altInput.setAttribute('data-toggle-if', this.input.getAttribute('data-toggle-if'))
          }
        },
      })
    })

    $dateRanges.forEach(($el) => {
      const datesData = $el.dataset.dates ? JSON.parse($el.dataset.dates) : null

      flatpickr($el.querySelector('input[name=date]'), {
        altInput: true,
        mode: 'range',
        altFormat: 'M j, Y',
        disableMobile: true,
        onClose: (selectedDates, _, instance) => {
          if (selectedDates.length == 2) {
            const from = instance.formatDate(selectedDates[0], 'Y-m-d')
            const to = instance.formatDate(selectedDates[1], 'Y-m-d')

            window.location.href = `${$el.closest('form').action}?from=${from}&to=${to}`
          }
        },
        onDayCreate: (dObj, dStr, fp, dayElem) => {
          if (datesData && datesData.includes(fp.formatDate(dayElem.dateObj, 'Y-m-d'))) {
            dayElem.classList.add('is-highlighted')
          }
        },
      })
    })
  },
}

export default {
  can: () => true,
  run: fn.init,
}
